"use client";

import { Spinner, type SpinnerProps } from "@nextui-org/react";

function Loading(params: SpinnerProps) {
  return (
    <div className=" w-full h-full flex items-center justify-center bg-transparent">
      <Spinner color="default" {...params} />
    </div>
  );
}

export default Loading;
